import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SelectFilterV2Component} from 'src/app/components/common/select-filter-v2/select-filter-v2.component';
import {Order, Sort, UrlParameter} from 'src/app/shared/utils/url.builder';
import {SelectElementV2} from 'src/app/components/common/select/selectElementV2';
import {FormGroup} from '@angular/forms';
import {SaleProductSummaryFindAllService} from "../../service/saleProductSummaryFindAll.service";
import {SaleProductSummaryModel} from "../../entity/saleProductSummary.model";
import {MomentAdapter} from "../../../../../../../shared/utils/moment.utils";

@Component({
  selector: 'app-sale-product-select',
  standalone: true,
    imports: [CommonModule, SelectFilterV2Component],
  templateUrl: './sale-product-select.component.html',
  providers: [
    SaleProductSummaryFindAllService
  ]
})
export class SaleProductSelectComponent implements OnChanges, OnInit {

  @Input() parentFormGroup: FormGroup;
  @Input() parentFormControlName: string;
  @Input() parameters: UrlParameter[] = [];
  @Input() sort: Sort = new Sort('name', Order.ASCENDING);

  @Output() singleSelectionChangeEvent = new EventEmitter<SaleProductSummaryModel>();
  @Output() elementsLoadedEvent = new EventEmitter<SaleProductSummaryModel[]>();

  elements: SelectElementV2<SaleProductSummaryModel>[] = [];

  constructor(public findAllService: SaleProductSummaryFindAllService) {
  }

  ngOnInit() {
    this.refresh();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['parameters'] && changes['parameters'].firstChange) || changes['sort']) {
      this.refresh();
    }
  }

  refresh() {
    this.elements = [];
    if (this.parameters?.length > 0) {
      this.findAllService.parameters = this.parameters;
      this.findAllService.sort = this.sort;
      this.findAllService.findAll().then(values => {
        if (values) {
          this.elementsLoadedEvent.emit(values);
          this.elements = values.map(value => {
            return {
              value: value.id,
              label: MomentAdapter.of(value.dateTime).formatDDMMYYY() + ' - ' + value.product.label,
              element: value
            };
          });
        }
      });
    }
  }
}
